(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.querySelector('layered-slideshow-component');
  if (!section) return;

  function getActiveIndex(tabs) {
    return [...tabs].findIndex(t => t.getAttribute('aria-selected') === 'true');
  }

  section.querySelector('.kemizon-arrow--prev')?.addEventListener('click', () => {
    const tabs = section.querySelectorAll('[role="tab"]');
    const current = getActiveIndex(tabs);
    const prev = (current - 1 + tabs.length) % tabs.length;
    tabs[prev].click();
  });

  section.querySelector('.kemizon-arrow--next')?.addEventListener('click', () => {
    const tabs = section.querySelectorAll('[role="tab"]');
    const current = getActiveIndex(tabs);
    const next = (current + 1) % tabs.length;
    tabs[next].click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
